import { useEffect, useRef, useState } from "react";
//Hook para manejar el canal de comunicación entre el padre y el iframe.
const useMapFrameChannel = () => {
  const apiKeyRef = useRef("");
  const [apiKey, setApiKey] = useState("");
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    const onMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      const data = event.data;
      if (!data || (data.type !== "init" && data.type !== "update")) return;
      if (data.type === "init" && !apiKeyRef.current && data.apiKey) {
        apiKeyRef.current = data.apiKey;
        setApiKey(data.apiKey);
      }
      setPayload(data);
    };
    window.addEventListener("message", onMessage);
    window.parent.postMessage({ type: "ready" }, window.location.origin);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return { apiKey, payload };
};

export default useMapFrameChannel;
